import { axios, handleError } from '../../lib'
import toast from 'react-hot-toast'
import TYPES from '../types'
import Cookies from 'js-cookie'

const altUserData = (data) => ({
  type: TYPES.ALT_USER_DATA,
  data,
})

const Itemoders = (data) => ({
  type: TYPES.USER_Orders,
  data,
})

const tracking = (data) => ({
  type: TYPES.tracker,
  data
})

// Initialize auth state from localStorage on app load
export const initializeAuth = () => (dispatch) => {
  console.log('=== Initializing Auth from localStorage ===')
  try {
    const authDataStr = localStorage.getItem('authData')
    const isLoggedIn = localStorage.getItem('isLoggedIn')
    
    console.log('authData from localStorage:', authDataStr)
    console.log('isLoggedIn from localStorage:', isLoggedIn)
    
    if (authDataStr && isLoggedIn === 'true') {
      const authData = JSON.parse(authDataStr)
      console.log('Parsed authData:', authData)
      
      // Restore user data and auth state
      if (authData.profile) {
        dispatch(altUserData(authData.profile))
        dispatch({ type: TYPES.ALT_AUTH_STATE, data: true })
        console.log('✅ Auth state restored from localStorage:', authData.profile)
      } else {
        console.warn('⚠️ No profile found in authData')
        dispatch({ type: TYPES.LOGOUT })
      }
    } else {
      console.log('❌ No valid auth data found - user not logged in')
      dispatch({ type: TYPES.LOGOUT })
    }
  } catch (error) {
    console.error('❌ Error initializing auth:', error)
    // Clear invalid data
    localStorage.removeItem('authData')
    localStorage.removeItem('isLoggedIn')
    localStorage.removeItem('userEmail')
    dispatch({ type: TYPES.LOGOUT })
  }
  console.log('=== Auth Initialization Complete ===')
}

export const signUp = (data, navigate) => async (dispatch, getState) => {
  let admin = { "admin": false }
  let result = { ...data, ...admin }
  Cookies.set("email", data.email)

  try {
    const { status, message } = await axios.post(
      '/auth/signup',
      {
        ...result,
        phone_number: data.phone_number.includes('+234')
          ? data.phone_number
          : `+234${data.phone_number.slice(1, data.phone_number.length)}`,
      },
    )

    if (status === 201) {
      toast.success(message)
      navigate('/auth/confirm-email')
      return { status }
    }
  } catch ({ response }) {
    handleError(response)
  }
}

export const confirmEmail = (data) => async (dispatch, getState) => {
  let email = Cookies.get("email");

  try {
    const { status } = await axios.post(`/auth/verify_user?email=${email}&token=${data.token}`)

    if (status) {
      toast.success('Email verified successfully')
      return status
    }
  } catch ({ response }) {
    handleError(response)
  }
}

export const forgottenPassword = (data) => async (dispatch, getState) => {
  try {
    const { status, ...response } = await axios.post(`/auth/forgot-password`, data)
    if (status === 201) {
      toast.success(response.message || 'OTP sent to your email')
      return { status, message: response.message }
    }
  } catch ({ response }) {
    handleError(response)
  }
}

export const verifyOTP = (data) => async (dispatch, getState) => {
  try {
    const { status, ...response } = await axios.post(`/auth/verify-otp`, data)
    if (status === 201) {
      toast.success(response.message || 'OTP verified successfully')
      // Store the temporary token for password reset
      sessionStorage.setItem('resetToken', response.data.token)
      sessionStorage.setItem('resetUserId', response.data.userId)
      return { status, data: response.data, message: response.message }
    }
  } catch ({ response }) {
    handleError(response)
  }
}

export const resetPassword = (data) => async (dispatch, getState) => {
  try {
    const resetToken = sessionStorage.getItem('resetToken')
    const { status, ...response } = await axios.post(
      `/auth/change-password`,
      data,
      {
        headers: {
          'Authorization': `Bearer ${resetToken}`
        }
      }
    )
    if (status === 201) {
      toast.success(response.message || 'Password changed successfully')
      // Clear the reset token
      sessionStorage.removeItem('resetToken')
      sessionStorage.removeItem('resetUserId')
      return { status, message: response.message }
    }
  } catch ({ response }) {
    handleError(response)
  }
}
export const signIn = (data, navigate) => async (dispatch, getState) => {
  try {
    const response = await axios.post('/auth/login', data)
    console.log('Login response:', response)
    
    if (response && response.data) {
      // The axios interceptor returns response.data, so response.data is the actual data object
      // Structure: { token, refreshToken, profile, kyc, expires }
      const authData = response.data
      
      console.log('Auth data to store:', authData)
      
      // Store auth data in localStorage
      localStorage.setItem('authData', JSON.stringify(authData))
      localStorage.setItem('isLoggedIn', 'true')
      localStorage.setItem('userEmail', authData.profile.email)
      
      console.log('✅ Auth data stored in localStorage')
      console.log('Verification - reading back:', localStorage.getItem('authData'))
      
      // Also keep cookies for backwards compatibility (axios interceptor uses them)
      const cookieOptions = {
        expires: 7,
        path: '/',
        sameSite: 'lax'
      }
      Cookies.set('tokenData', JSON.stringify(authData), cookieOptions)
      Cookies.set('loggedin', 'true', cookieOptions)
      Cookies.set('email', authData.profile.email, cookieOptions)
      
      // Update Redux state
      dispatch(altUserData(authData.profile))
      dispatch({ type: TYPES.ALT_AUTH_STATE, data: true })

      // Get user type from response
      const userType = authData.profile.role
      console.log('User type:', userType, 'Profile:', authData.profile)

      // Navigate based on user type
      if (userType === 'ADMIN' || userType === 'SUPER_ADMIN') {
        navigate('/dashboard')
        toast.success('Welcome Admin!')
      } else if (userType === 'DRIVER') {
        navigate('/rider')
        toast.success('Welcome Driver!')
      } else if (userType === 'COMPANY') {
        navigate('/company/dashboard')
        toast.success('Welcome to your Company Dashboard!')
      } else {
        // Default for regular users
        navigate('/')
        toast.success('Login successful!')
      }

      return { status: 200 }
    }
  } catch (error) {
    console.error('Login error:', error)
    handleError(error.response)
  }
}

export const logout = (navigate) => async (dispatch) => {
  console.log('Logging out...')
  
  // Clear localStorage
  localStorage.removeItem('authData')
  localStorage.removeItem('isLoggedIn')
  localStorage.removeItem('userEmail')
  
  // Clear all auth-related cookies
  Cookies.remove('loggedin')
  Cookies.remove('tokenData')
  Cookies.remove('email')

  // Clear all storage
  sessionStorage.clear()

  // Dispatch logout action to clear Redux state
  dispatch({
    type: TYPES.LOGOUT,
  })

  console.log('✅ All auth data cleared')
  
  // Show success message
  toast.success('Logged out successfully')

  // Redirect to login page if navigate is provided
  if (navigate) {
    navigate('/auth/sign-in')
  } else if (typeof window !== 'undefined') {
    // Fallback: use window.location if navigate not provided
    window.location.href = '/auth/sign-in'
  }
}

export const resendVerificationMail = (data) => async (dispatch, getState) => {
  try {
    const { status, message } = await axios.post(`/auth/resend_verification?email=${Cookies.get("email")}`)
    if (status === 201) {
      toast.success(message)
    }
  } catch ({ response }) {
    handleError(response)
  }
}
export const createOrder = (data) => async (dispatch, getState) => {

  try {
    const { status, message } = await axios.post('/user/create_order', data)
    if (status === 201) {
      toast.success(message)
    }
  } catch ({ response }) {
    handleError(response)
  }
}

export const contactUs = (data, navigate) => async (dispatch, getState) => {
  try {
    const { status, message } = await axios.post('/user/create_message', data)

    if (status === 201) {
      toast.success(message)
      navigate("/")
    }
  } catch ({ response }) {
    handleError(response)
  }
}


export const getOrder = (data) => async (dispatch, getState) => {
  try {
    const { ...response } = await axios.get('/user/orders')

    dispatch(Itemoders(response.data.orders))

  } catch ({ response }) {

    handleError(response)
  }
}

export const getOrderByTrackingNo = (data) => async (dispatch, getState) => {
  try {
    const { status, ...response } = await axios.post('/admin/order_details', data)
    if (status === 200) {
      dispatch(tracking(response.data.orders[0]))
    }
  } catch ({ response }) {
    handleError(response)
  }
}


export const creatOrder = (data, navigate, setData, set) => async (dispatch, getState) => {
  const orders = { ...data, weight: { "unit": "kg", "value": data.weights } }
  try {
    const { status, data: responseData, message } = await axios.post('/user/create_order', orders)

    if (status === 201) {
      toast.success(message)
      setData({ id: responseData.order.id, amount: responseData.order.amount, reference: responseData.order.reference })

      navigate('/delievery-request/step-3')
    }
    return { status }
  } catch ({ response }) {
    handleError(response)
  }
}

export const updateOrder = (data) => async (dispatch, getState) => {

  try {
    const { status } = await axios.post('/user/update_order_payment', data)

    if (status === 200) {
      toast.success("order was updated successfully")

    }
    return { status }
  } catch ({ response }) {
    handleError(response)
  }
}
